module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/v/about.svg?32bd3adabfb95aff0f445ee2020505a3";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/v/about.svg
// module id = 85
// module chunks = 0